var _circle, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2575 19.6395C16.2575 15.1442 19.7239 11.5 24 11.5C28.2761 11.5 31.7425 15.1442 31.7425 19.6395V23.1612C31.7425 24.6249 32.3536 26.0245 33.4329 27.0331C34.6189 28.1414 33.8207 30.1046 32.1841 30.1046H15.8159C14.1793 30.1046 13.3811 28.1414 14.5671 27.0331C15.6464 26.0245 16.2575 24.6249 16.2575 23.1612V19.6395Z",
    fill: "#868FA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 36.5C26.0995 36.5 27.8013 34.9011 27.8013 32.9286C27.8013 32.8952 27.8008 32.8618 27.7999 32.8286C27.7914 32.5405 27.5255 32.331 27.2188 32.3277L20.7969 32.2593C20.4902 32.256 20.2193 32.4598 20.204 32.7476C20.2008 32.8076 20.1992 32.8679 20.1992 32.9286C20.1992 34.9011 21.901 36.5 24.0003 36.5Z",
    fill: "#868FA0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_127_7257)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.75,
    cy: 14,
    r: 5,
    fill: "#E01919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_127_7257",
    x: 25.25,
    y: 6.5,
    width: 15,
    height: 16.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_127_7257"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.968627 0 0 0 0 0.975163 0 0 0 0 0.988235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_127_7257"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_127_7257",
    result: "effect2_dropShadow_127_7257"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_127_7257",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.47554c652d02530ce9f8451cfb12cde8.svg";
export { ForwardRef as ReactComponent };